import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroUsuario'
})
export class FiltroUsuarioPipe implements PipeTransform {

  transform(value: any, arg: any): any {    
    const resultPosts= [];
    for (const post of value) {
      if(post.nombre.indexOf(arg) > -1){ 
        // console.log(arg);                      
        resultPosts.push(post);
      }; 
    };
    return resultPosts;
  }

}
